import React from "react";

const Footer = () => {
  return (
    <footer className="p-3 text-center bg-dark text-white">
      With Love &amp; React for Alyra
    </footer>
  );
};

export default Footer;
